module.exports = __webpack_public_path__ + "static/media/Create_Campaign.a26f1548.pdf";